import { render, staticRenderFns } from "./activity-config-pop.vue?vue&type=template&id=7c053c16&scoped=true&"
import script from "./activity-config-pop.vue?vue&type=script&lang=js&"
export * from "./activity-config-pop.vue?vue&type=script&lang=js&"
import style0 from "./activity-config-pop.vue?vue&type=style&index=0&id=7c053c16&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c053c16",
  null
  
)

export default component.exports